import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';

export type PowerOutageCountyProperties = {
  boundaryId: string;
  stateName: string | null;
  countyName: string | null;
  customersTracked: number;
  customersOut: number;
  /** 0-100 */
  percentOut: number;
  lastUpdated: string | null;
};

export type CountyFeatureCollection<P> = {
  type: 'FeatureCollection';
  features: Array<{
    type: 'Feature';
    id?: string | number;
    geometry: unknown;
    properties: P;
  }>;
};

export type PowerOutageCountiesResponse = {
  /** ISO timestamp of the PowerOutage.us snapshot, null when the table is empty. */
  asOf: string | null;
  featureCollection: CountyFeatureCollection<PowerOutageCountyProperties>;
};

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export const powerOutageCountiesQueryKey = [
  'map',
  'powerOutageCounties',
] as const;

/**
 * Latest county-level PowerOutage.us snapshot; only fetched while the layer is
 * shown.
 */
export const usePowerOutageCounties = (enabled: boolean) => {
  return useQuery({
    queryKey: powerOutageCountiesQueryKey,
    enabled,
    staleTime: FIVE_MINUTES_MS,
    refetchInterval: enabled ? FIVE_MINUTES_MS : false,
    queryFn: async () => {
      const response = await axios.get<PowerOutageCountiesResponse>(
        config.apiGateway.powerOutageCounties
      );
      return response.data;
    },
  });
};
